import React from 'react';
import { ClientCard } from '../../components/clients/ClientCard';
import { Client } from '../../types/client';

interface ArchivedClientsListProps {
  clients: Client[];
}

export const ArchivedClientsList: React.FC<ArchivedClientsListProps> = ({ clients }) => {
  if (clients.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500 dark:text-gray-400">
          Aucun client archivé trouvé
        </p>
      </div>
    );
  }

  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {clients.map((client) => (
        <ClientCard key={client.id} client={client} />
      ))}
    </div>
  );
};